import { Skeleton } from '@material-ui/lab';
import React from 'react';

const Header = () => (
  <Skeleton animation="wave" variant="rect" height={80} />
);

export default Header;
